module.exports = __webpack_public_path__ + "static/media/wm_bg_morning.ae3b390f.jpg";